import React, { useState } from 'react'

import { v4 } from 'uuid'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Switch,
  FormControlLabel,
  MenuItem,
  Tooltip,
  IconButton,
} from '@mui/material'
import { formatToPhone } from '../../../utils/string'
import { OpenInNew } from '@mui/icons-material'

const ContactForm = ({
  onCommit,
  existingContact,
  isOpen,
  handleClose,
  hasDefault,
  contactTypesQuery,
}) => {
  const [contact, setContact] = useState(
    existingContact ?? {
      id: v4(),
      isNew: true,
      firstName: null,
      lastName: null,
      title: null,
      phoneNumber: null,
      phoneExt: null,
      emailAddress: null,
      isDefault: !hasDefault,
      typeId: null,
    }
  )

  const updateContact = (key, e) => {
    setContact({ ...contact, [key]: e.target.value })
  }

  const { contactTypes, isLoading, hasLoadError } = contactTypesQuery

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'sm'}>
      <DialogTitle>
        {existingContact
          ? `Edit ${existingContact.firstName} ${existingContact.lastName}`
          : 'New Contact'}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          value={contact.firstName || ''}
          label='First Name'
          onChange={(e) => updateContact('firstName', e)}
          margin='dense'
          autoFocus
        />
        <TextField
          fullWidth
          value={contact.lastName || ''}
          label='Last Name'
          onChange={(e) => updateContact('lastName', e)}
          margin='dense'
        />

        <TextField
          fullWidth
          value={contact.title || ''}
          label='Title'
          onChange={(e) => updateContact('title', e)}
          margin='dense'
        />

        {!isLoading && !hasLoadError && (
          <TextField
            margin='dense'
            fullWidth
            label={'Influence'}
            value={contact.typeId || ''}
            onChange={(e) => updateContact('typeId', e)}
            select
          >
            <MenuItem value={''}>None</MenuItem>
            {contactTypes
              .filter((c) => !!c.name)
              .map((c, i) => (
                <MenuItem key={i} value={c.id}>
                  {c.name}
                </MenuItem>
              ))}
          </TextField>
        )}

        <div className='flex'>
          <TextField
            fullWidth
            value={formatToPhone(contact.phoneNumber || '')}
            label='Phone Number'
            onChange={(e) => updateContact('phoneNumber', e)}
            margin='dense'
            InputProps={{
              style: {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              },
            }}
          />
          <div className='third'>
            <TextField
              fullWidth
              value={contact.phoneExt || ''}
              label='Ext'
              onChange={(e) => updateContact('phoneExt', e)}
              margin='dense'
              InputProps={{
                style: {
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderLeft: 'none',
                },
              }}
            />
          </div>
        </div>

        <TextField
          fullWidth
          value={contact.mobilePhoneNumber || ''}
          label='Mobile Phone Number'
          onChange={(e) => updateContact('mobilePhoneNumber', e)}
          margin='dense'
        />
        <TextField
          fullWidth
          value={contact.emailAddress || ''}
          label='Email Address'
          onChange={(e) => updateContact('emailAddress', e)}
          margin='dense'
        />

        <TextField
          fullWidth
          margin='dense'
          label='Social Media Link'
          onChange={(e) => updateContact('socialMediaLink', e)}
          value={contact.socialMediaLink}
          InputProps={{
            endAdornment: contact.socialMediaLink ? (
              <Tooltip title={'Go to ' + contact.socialMediaLink}>
                <IconButton
                  color={'primary'}
                  sx={{ flexGrow: 0 }}
                  onClick={() => {
                    window.open(
                      contact.socialMediaLink.match(/^https?:/)
                        ? contact.socialMediaLink
                        : '//' + contact.socialMediaLink,
                      '_blank'
                    )
                  }}
                >
                  <OpenInNew />
                </IconButton>
              </Tooltip>
            ) : null,
          }}
        />

        <FormControlLabel
          label={'Is primary contact'}
          control={
            <Switch
              checked={contact.isDefault}
              onChange={(e) =>
                setContact({
                  ...contact,
                  isDefault: e.target.checked,
                })
              }
            />
          }
        ></FormControlLabel>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          color='primary'
          variant='contained'
          onClick={() => onCommit(contact)}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ContactForm
